// Tax ID options for the dropdown selector
// Ordered alphabetically by country name
// Based on official Stripe supported tax ID types: https://docs.stripe.com/billing/customer/tax-ids

export const TAX_ID_OPTIONS = [
  // A
  {
    value: 'al_tin',
    label: '🇦🇱 AL TIN',
    country: 'Albania',
    placeholder: 'J12345678N',
  },
  {
    value: 'ad_nrt',
    label: '🇦🇩 AD NRT',
    country: 'Andorra',
    placeholder: 'A-123456-Z',
  },
  {
    value: 'ao_tin',
    label: '🇦🇴 AO TIN',
    country: 'Angola',
    placeholder: '5123456789',
  },
  {
    value: 'ar_cuit',
    label: '🇦🇷 AR CUIT',
    country: 'Argentina',
    placeholder: '12-3456789-01',
  },
  {
    value: 'am_tin',
    label: '🇦🇲 AM TIN',
    country: 'Armenia',
    placeholder: '02538904',
  },
  {
    value: 'aw_tin',
    label: '🇦🇼 AW TIN',
    country: 'Aruba',
    placeholder: '12345678',
  },
  {
    value: 'au_abn',
    label: '🇦🇺 AU ABN',
    country: 'Australia',
    placeholder: '12345678912',
  },
  {
    value: 'au_arn',
    label: '🇦🇺 AU ARN',
    country: 'Australia',
    placeholder: '123456789012',
  },
  {
    value: 'az_tin',
    label: '🇦🇿 AZ TIN',
    country: 'Azerbaijan',
    placeholder: '0123456789',
  },

  // B
  {
    value: 'bs_tin',
    label: '🇧🇸 BS TIN',
    country: 'Bahamas',
    placeholder: '123.456.789',
  },
  {
    value: 'bh_vat',
    label: '🇧🇭 BH VAT',
    country: 'Bahrain',
    placeholder: '123456789012345',
  },
  {
    value: 'bd_bin',
    label: '🇧🇩 BD BIN',
    country: 'Bangladesh',
    placeholder: '123456789-0123',
  },
  {
    value: 'bb_tin',
    label: '🇧🇧 BB TIN',
    country: 'Barbados',
    placeholder: '1123456789012',
  },
  {
    value: 'by_tin',
    label: '🇧🇾 BY TIN',
    country: 'Belarus',
    placeholder: '123456789',
  },
  {
    value: 'bj_ifu',
    label: '🇧🇯 BJ IFU',
    country: 'Benin',
    placeholder: '1234567890123',
  },
  {
    value: 'bo_tin',
    label: '🇧🇴 BO TIN',
    country: 'Bolivia',
    placeholder: '123456789',
  },
  {
    value: 'ba_tin',
    label: '🇧🇦 BA TIN',
    country: 'Bosnia and Herzegovina',
    placeholder: '123456789012',
  },
  {
    value: 'br_cnpj',
    label: '🇧🇷 BR CNPJ',
    country: 'Brazil',
    placeholder: '01.234.456/5432-10',
  },
  {
    value: 'br_cpf',
    label: '🇧🇷 BR CPF',
    country: 'Brazil',
    placeholder: '123.456.789-87',
  },
  {
    value: 'bg_uic',
    label: '🇧🇬 BG UIC',
    country: 'Bulgaria',
    placeholder: '123456789',
  },
  {
    value: 'bf_ifu',
    label: '🇧🇫 BF IFU',
    country: 'Burkina Faso',
    placeholder: '12345678A',
  },

  // C
  {
    value: 'kh_tin',
    label: '🇰🇭 KH TIN',
    country: 'Cambodia',
    placeholder: '1001-123456789',
  },
  {
    value: 'cm_niu',
    label: '🇨🇲 CM NIU',
    country: 'Cameroon',
    placeholder: 'M123456789000L',
  },
  {
    value: 'ca_bn',
    label: '🇨🇦 CA BN',
    country: 'Canada',
    placeholder: '123456789',
  },
  {
    value: 'ca_gst_hst',
    label: '🇨🇦 CA GST/HST',
    country: 'Canada',
    placeholder: '123456789RT0002',
  },
  {
    value: 'ca_pst_bc',
    label: '🇨🇦 CA PST BC',
    country: 'Canada (BC)',
    placeholder: 'PST-1234-5678',
  },
  {
    value: 'ca_pst_mb',
    label: '🇨🇦 CA PST MB',
    country: 'Canada (MB)',
    placeholder: '123456-7',
  },
  {
    value: 'ca_pst_sk',
    label: '🇨🇦 CA PST SK',
    country: 'Canada (SK)',
    placeholder: '1234567',
  },
  {
    value: 'ca_qst',
    label: '🇨🇦 CA QST',
    country: 'Canada (QC)',
    placeholder: '1234567890TQ1234',
  },
  {
    value: 'cv_nif',
    label: '🇨🇻 CV NIF',
    country: 'Cape Verde',
    placeholder: '213456789',
  },
  {
    value: 'cl_tin',
    label: '🇨🇱 CL TIN',
    country: 'Chile',
    placeholder: '12.345.678-K',
  },
  {
    value: 'cn_tin',
    label: '🇨🇳 CN TIN',
    country: 'China',
    placeholder: '123456789012345678',
  },
  {
    value: 'co_nit',
    label: '🇨🇴 CO NIT',
    country: 'Colombia',
    placeholder: '123.456.789-0',
  },
  {
    value: 'cd_nif',
    label: '🇨🇩 CD NIF',
    country: 'Congo (DR)',
    placeholder: 'A0123456M',
  },
  {
    value: 'cr_tin',
    label: '🇨🇷 CR TIN',
    country: 'Costa Rica',
    placeholder: '1-234-567890',
  },
  {
    value: 'hr_oib',
    label: '🇭🇷 HR OIB',
    country: 'Croatia',
    placeholder: '12345678901',
  },

  // D
  {
    value: 'do_rcn',
    label: '🇩🇴 DO RCN',
    country: 'Dominican Republic',
    placeholder: '123-4567890-1',
  },

  // E
  {
    value: 'ec_ruc',
    label: '🇪🇨 EC RUC',
    country: 'Ecuador',
    placeholder: '1234567890001',
  },
  {
    value: 'eg_tin',
    label: '🇪🇬 EG TIN',
    country: 'Egypt',
    placeholder: '123456789',
  },
  {
    value: 'sv_nit',
    label: '🇸🇻 SV NIT',
    country: 'El Salvador',
    placeholder: '1234-567890-123-4',
  },
  {
    value: 'et_tin',
    label: '🇪🇹 ET TIN',
    country: 'Ethiopia',
    placeholder: '1234567890',
  },
  {
    value: 'eu_vat',
    label: '🇪🇺 EU VAT',
    country: 'European Union',
    placeholder: 'DE123456789',
  },
  {
    value: 'eu_oss_vat',
    label: '🇪🇺 EU OSS VAT',
    country: 'EU One Stop Shop',
    placeholder: 'EU123456789',
  },

  // F

  // G
  {
    value: 'ge_vat',
    label: '🇬🇪 GE VAT',
    country: 'Georgia',
    placeholder: '123456789',
  },
  {
    value: 'gn_nif',
    label: '🇬🇳 GN NIF',
    country: 'Guinea',
    placeholder: '123456789',
  },
  {
    value: 'de_stn',
    label: '🇩🇪 DE STN',
    country: 'Germany',
    placeholder: '12345678901',
  },

  // H
  {
    value: 'hk_br',
    label: '🇭🇰 HK BR',
    country: 'Hong Kong',
    placeholder: '12345678',
  },
  {
    value: 'hu_tin',
    label: '🇭🇺 HU TIN',
    country: 'Hungary',
    placeholder: '1234567890',
  },

  // I
  {
    value: 'is_vat',
    label: '🇮🇸 IS VAT',
    country: 'Iceland',
    placeholder: '12345',
  },
  {
    value: 'in_gst',
    label: '🇮🇳 IN GST',
    country: 'India',
    placeholder: '12ABCDE1234F1Z5',
  },
  {
    value: 'id_npwp',
    label: '🇮🇩 ID NPWP',
    country: 'Indonesia',
    placeholder: '12.123.123.1-123.123',
  },
  {
    value: 'il_vat',
    label: '🇮🇱 IL VAT',
    country: 'Israel',
    placeholder: '123456789',
  },

  // J
  {
    value: 'jp_cn',
    label: '🇯🇵 JP CN',
    country: 'Japan',
    placeholder: '1234567890123',
  },
  {
    value: 'jp_rn',
    label: '🇯🇵 JP RN',
    country: 'Japan',
    placeholder: '123456789012',
  },
  {
    value: 'jp_trn',
    label: '🇯🇵 JP TRN',
    country: 'Japan',
    placeholder: 'T1234567890123',
  },

  // K
  {
    value: 'kz_bin',
    label: '🇰🇿 KZ BIN',
    country: 'Kazakhstan',
    placeholder: '123456789012',
  },
  {
    value: 'ke_pin',
    label: '🇰🇪 KE PIN',
    country: 'Kenya',
    placeholder: 'A123456789Z',
  },
  {
    value: 'kg_tin',
    label: '🇰🇬 KG TIN',
    country: 'Kyrgyzstan',
    placeholder: '123456789',
  },

  // L
  {
    value: 'la_tin',
    label: '🇱🇦 LA TIN',
    country: 'Laos',
    placeholder: '123456789',
  },
  {
    value: 'li_uid',
    label: '🇱🇮 LI UID',
    country: 'Liechtenstein',
    placeholder: 'LI123456',
  },
  {
    value: 'li_vat',
    label: '🇱🇮 LI VAT',
    country: 'Liechtenstein',
    placeholder: 'LI12345',
  },

  // M
  {
    value: 'my_frp',
    label: '🇲🇾 MY FRP',
    country: 'Malaysia',
    placeholder: '12345678',
  },
  {
    value: 'my_itn',
    label: '🇲🇾 MY ITN',
    country: 'Malaysia',
    placeholder: 'C1234567890',
  },
  {
    value: 'my_sst',
    label: '🇲🇾 MY SST',
    country: 'Malaysia',
    placeholder: 'A12-3456-78912345',
  },
  {
    value: 'mr_nif',
    label: '🇲🇷 MR NIF',
    country: 'Mauritania',
    placeholder: '1234567890123',
  },
  {
    value: 'mx_rfc',
    label: '🇲🇽 MX RFC',
    country: 'Mexico',
    placeholder: 'ABC010203AB9',
  },
  {
    value: 'md_vat',
    label: '🇲🇩 MD VAT',
    country: 'Moldova',
    placeholder: '1234567',
  },
  {
    value: 'me_pib',
    label: '🇲🇪 ME PIB',
    country: 'Montenegro',
    placeholder: '12345678',
  },
  {
    value: 'ma_vat',
    label: '🇲🇦 MA VAT',
    country: 'Morocco',
    placeholder: '123456789012345',
  },

  // N
  {
    value: 'np_pan',
    label: '🇳🇵 NP PAN',
    country: 'Nepal',
    placeholder: '123456789',
  },
  {
    value: 'nz_gst',
    label: '🇳🇿 NZ GST',
    country: 'New Zealand',
    placeholder: '123456789',
  },
  {
    value: 'ng_tin',
    label: '🇳🇬 NG TIN',
    country: 'Nigeria',
    placeholder: '12345678-0001',
  },
  {
    value: 'mk_vat',
    label: '🇲🇰 MK VAT',
    country: 'North Macedonia',
    placeholder: '4030998612347',
  },
  {
    value: 'no_vat',
    label: '🇳🇴 NO VAT',
    country: 'Norway',
    placeholder: '123456789MVA',
  },
  {
    value: 'no_voec',
    label: '🇳🇴 NO VOEC',
    country: 'Norway',
    placeholder: '1234567',
  },

  // O
  {
    value: 'om_vat',
    label: '🇴🇲 OM VAT',
    country: 'Oman',
    placeholder: 'OM1234567890',
  },

  // P
  {
    value: 'pe_ruc',
    label: '🇵🇪 PE RUC',
    country: 'Peru',
    placeholder: '12345678901',
  },
  {
    value: 'ph_tin',
    label: '🇵🇭 PH TIN',
    country: 'Philippines',
    placeholder: '123456789012',
  },

  // Q

  // R
  {
    value: 'ro_tin',
    label: '🇷🇴 RO TIN',
    country: 'Romania',
    placeholder: '1234567890123',
  },
  {
    value: 'ru_inn',
    label: '🇷🇺 RU INN',
    country: 'Russia',
    placeholder: '1234567891',
  },
  {
    value: 'ru_kpp',
    label: '🇷🇺 RU KPP',
    country: 'Russia',
    placeholder: '123456789',
  },

  // S
  {
    value: 'sa_vat',
    label: '🇸🇦 SA VAT',
    country: 'Saudi Arabia',
    placeholder: '123456789012345',
  },
  {
    value: 'sn_ninea',
    label: '🇸🇳 SN NINEA',
    country: 'Senegal',
    placeholder: '12345672A2',
  },
  {
    value: 'rs_pib',
    label: '🇷🇸 RS PIB',
    country: 'Serbia',
    placeholder: '123456789',
  },
  {
    value: 'sg_gst',
    label: '🇸🇬 SG GST',
    country: 'Singapore',
    placeholder: 'M12345678X',
  },
  {
    value: 'sg_uen',
    label: '🇸🇬 SG UEN',
    country: 'Singapore',
    placeholder: '123456789F',
  },
  {
    value: 'si_tin',
    label: '🇸🇮 SI TIN',
    country: 'Slovenia',
    placeholder: '12345678',
  },
  {
    value: 'za_vat',
    label: '🇿🇦 ZA VAT',
    country: 'South Africa',
    placeholder: '4123456789',
  },
  {
    value: 'kr_brn',
    label: '🇰🇷 KR BRN',
    country: 'South Korea',
    placeholder: '123-45-67890',
  },
  {
    value: 'es_cif',
    label: '🇪🇸 ES CIF',
    country: 'Spain',
    placeholder: 'A12345678',
  },
  {
    value: 'sr_fin',
    label: '🇸🇷 SR FIN',
    country: 'Suriname',
    placeholder: '1234567890',
  },
  {
    value: 'ch_uid',
    label: '🇨🇭 CH UID',
    country: 'Switzerland',
    placeholder: 'CHE-123.456.789 HR',
  },
  {
    value: 'ch_vat',
    label: '🇨🇭 CH VAT',
    country: 'Switzerland',
    placeholder: 'CHE-123.456.789 MWST',
  },

  // T
  {
    value: 'tw_vat',
    label: '🇹🇼 TW VAT',
    country: 'Taiwan',
    placeholder: '12345678',
  },
  {
    value: 'tj_tin',
    label: '🇹🇯 TJ TIN',
    country: 'Tajikistan',
    placeholder: '123456789',
  },
  {
    value: 'tz_vat',
    label: '🇹🇿 TZ VAT',
    country: 'Tanzania',
    placeholder: '12345678A',
  },
  {
    value: 'th_vat',
    label: '🇹🇭 TH VAT',
    country: 'Thailand',
    placeholder: '1234567891234',
  },
  {
    value: 'tr_tin',
    label: '🇹🇷 TR TIN',
    country: 'Turkey',
    placeholder: '0123456789',
  },

  // U
  {
    value: 'ug_tin',
    label: '🇺🇬 UG TIN',
    country: 'Uganda',
    placeholder: '1014751879',
  },
  {
    value: 'ua_vat',
    label: '🇺🇦 UA VAT',
    country: 'Ukraine',
    placeholder: '123456789',
  },
  {
    value: 'ae_trn',
    label: '🇦🇪 AE TRN',
    country: 'United Arab Emirates',
    placeholder: '123456789012345',
  },
  {
    value: 'gb_vat',
    label: '🇬🇧 GB VAT',
    country: 'United Kingdom',
    placeholder: 'GB123456789',
  },
  {
    value: 'us_ein',
    label: '🇺🇸 US EIN',
    country: 'United States',
    placeholder: '12-3456789',
  },
  {
    value: 'uy_ruc',
    label: '🇺🇾 UY RUC',
    country: 'Uruguay',
    placeholder: '123456789012',
  },
  {
    value: 'uz_tin',
    label: '🇺🇿 UZ TIN',
    country: 'Uzbekistan',
    placeholder: '123456789',
  },
  {
    value: 'uz_vat',
    label: '🇺🇿 UZ VAT',
    country: 'Uzbekistan',
    placeholder: '123456789012',
  },

  // V
  {
    value: 've_rif',
    label: '🇻🇪 VE RIF',
    country: 'Venezuela',
    placeholder: 'A-12345678-9',
  },
  {
    value: 'vn_tin',
    label: '🇻🇳 VN TIN',
    country: 'Vietnam',
    placeholder: '1234567890',
  },

  // Y

  // Z
  {
    value: 'zm_tin',
    label: '🇿🇲 ZM TIN',
    country: 'Zambia',
    placeholder: '1004751879',
  },
  {
    value: 'zw_tin',
    label: '🇿🇼 ZW TIN',
    country: 'Zimbabwe',
    placeholder: '1234567890',
  },
];

/**
 * Filters tax ID options based on search term
 * @param {Array} options - Array of tax ID options
 * @param {string} searchTerm - Search term to filter by
 * @returns {Array} Filtered options
 */
export const filterTaxIdOptions = (options, searchTerm) => {
  if (!searchTerm) return options;

  const term = searchTerm.toLowerCase();
  return options.filter(
    (option) =>
      option.label.toLowerCase().includes(term) ||
      option.country.toLowerCase().includes(term) ||
      option.value.toLowerCase().includes(term)
  );
};

/**
 * Gets a specific tax ID option by value
 * @param {string} value - Tax ID type value
 * @returns {Object|null} Tax ID option or null if not found
 */
export const getTaxIdOption = (value) => {
  return TAX_ID_OPTIONS.find((option) => option.value === value) || null;
};
